import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import TripCards from "./TripCards";
import TripTable from "./TripTable";

export default function TripOverview({ highlightId, onSelect }: { highlightId?: string; onSelect: (id?: string) => void }) {

  const trips = useSelector((s: RootState) => s.fleet.trips);
  const list = Object.entries(trips).filter(([_, t]: any) => t?.started);
  const [view, setView] = useState<"cards" | "table">("table");

  return (
    <div className="py-4">
      <div className="flex justify-between items-center m-3">
        <h2 className="m-0 text-xl font-semibold">Trip Overview</h2>
        <div
          role="radiogroup"
          aria-label="View selector"
          className="inline-flex gap-1 bg-gray-100 p-1 rounded-lg"
        >
         
          <button
            role="radio"
            aria-checked={view === "table"}
            className={`px-3 py-1.5 rounded-md ${
              view === "table" ? "bg-[#171f54] text-white" : "bg-transparent"
            }`}
            onClick={() => setView("table")}
          >
            Table
          </button>
              <button
            role="radio"
            aria-checked={view === "cards"}
            className={`px-3 py-1.5 rounded-md ${
              view === "cards" ? "bg-[#171f54] text-white" : "bg-transparent"
            }`}
            onClick={() => setView("cards")}
          >
            Cards
          </button>
        </div>
      </div>

      {view === "cards" ? (
        <TripCards list={list} highlightId={highlightId} onSelect={onSelect} />
      ) : (
        <TripTable list={list} highlightId={highlightId} onSelect={onSelect} />
      )}
    </div>
  );
}
